import { LDSHttpClient } from './lds-http-client';
class LocalDevServerApiClient extends LDSHttpClient {
    async healthCheck() {
        const response = await this.get('/rl-marketplace/health-check');
        return response;
    }
    async getWidgets() {
        const response = await this.get('/widgets');
        return response;
    }
    async getWidgetById(widgetId) {
        const response = await this.get(`/widgets/${widgetId}`);
        return response;
    }
    async getWidgetFields(widgetId, payload) {
        const response = await this.post(`/widgets/${widgetId}/fields`, payload);
        return response;
    }
    async invokeServerMethod(name, context, payload, params) {
        return this.post(`/server-actions/${name}/run`, {
            context,
            payload
        }, {
            params
        });
    }
    async getAppConfig() {
        return this.get('/config');
    }
    async getClientEventsPage() {
        return this.get('/client-events');
    }
    async getInvokeServerActionResponse(requestId) {
        return this.get(`/server-actions/response/${requestId}`);
    }
}
const LdsApiClient = new LocalDevServerApiClient();
export { LdsApiClient };
